import { AfterViewInit, Injectable, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormGroup, ValidationErrors, Validator } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class FormService {

  public form: UntypedFormGroup;
  public formMap: Map<string, UntypedFormGroup>;

  public patterns;
  public validators;

  public formCreated: boolean;

  public valuesAtInit;
  public unsavedChanges: boolean = false;

  constructor() {
    this.formMap = new Map<string, UntypedFormGroup>();
  }

  public removeValidators(formGroup: UntypedFormGroup, emitEvent = true) {
    for (const key in formGroup.controls) {
      formGroup.get(key).clearValidators();
      formGroup.get(key).updateValueAndValidity({ emitEvent: emitEvent });
    }
  }

  public addValidators(formGroup: UntypedFormGroup, emitEvent = true) {
    for (const key in formGroup.controls) {
      formGroup.get(key).setValidators(this.validators[key]);
      formGroup.get(key).updateValueAndValidity({ emitEvent: emitEvent });
    }
  }

  public validateControl(controlName: string) {
    if (!this.form || !this.form.controls) {
      return false; 
    }

    const control = this.getControl(controlName);
    return control ? control.invalid && control.touched : false;
  }

  public hasError(controlName: string, errorName: string) {
    if (!this.form || !this.form.controls) {
      return false; 
    }

    const control = this.getControl(controlName);
    return control ? control.hasError(errorName) : false;
  }

  private getControl(controlName: string) {
    const controlNames = controlName.split('.');
    let control = this.form.get(controlNames[0]);

    for (let i = 1; i < controlNames.length && control; i++) {
      control = control.get(controlNames[i]);
    }

    return control;
  }

}
